module.exports = __webpack_public_path__ + "img/game.db6aa6d8.png";